import axios from "axios";
import { API_BASE_URL } from "../constants/api";
import { ACCESS_TOKEN } from "../constants/auth";

const AdminApplicationService = {};

AdminApplicationService.getApplications = async (
  page,
  limit,
  orderProperties = [],
  orderDirection = [],
  countries = [],
  cities = [],
  schools = [],
  schoolClasses = [],
  professions = [],
  applicationStatuses = []
) => {
  const params = {
    page,
    limit,
    orderProperties: orderProperties.length
      ? orderProperties.join(",")
      : undefined,
    orderDirection: orderDirection.length ? orderDirection[0] : undefined,
    countries: countries.length ? countries.join(",") : undefined,
    cities: cities.length ? cities.join(",") : undefined,
    schools: schools.length ? schools.join(",") : undefined,
    schoolClasses: schoolClasses.length ? schoolClasses.join(",") : undefined,
    professions: professions.length ? professions.join(";") : undefined,
    applicationStatuses: applicationStatuses.length
      ? applicationStatuses.join(",")
      : undefined,
  };

  return axios({
    method: "get",
    url: API_BASE_URL + "/api/admin/application/get",
    params,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

AdminApplicationService.downloadApplicationReport = async () => {
  return axios({
    method: "get",
    url: API_BASE_URL + "/api/admin/application/get/all/excel",
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
    responseType: "blob",
  });
};

AdminApplicationService.appointApplication = async (
  id,
  appointmentDateA,
  appointmentDateB,
  appointmentDateC,
  linkA,
  linkB,
  linkC,
  addressA,
  addressB,
  addressC
) => {
  const getDateString = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    return `${day}.${month}.${year}, ${hours}:${minutes}:${seconds}`;
  };

  let data = new FormData();
  data.append("appointmentDateA", getDateString(appointmentDateA));
  data.append("appointmentDateB", getDateString(appointmentDateB));
  data.append("appointmentDateC", getDateString(appointmentDateC));
  if (linkA) data.append("linkA", linkA);
  if (linkB) data.append("linkB", linkB);
  if (linkC) data.append("linkC", linkC);
  if (addressA) data.append("addressA", addressA);
  if (addressB) data.append("addressB", addressB);
  if (addressC) data.append("addressC", addressC);

  return axios({
    method: "post",
    url: API_BASE_URL + `/api/admin/application/${id}/appoint`,
    data: data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

AdminApplicationService.finishApplicationA = async (id) => {
  return axios({
    method: "post",
    url: API_BASE_URL + `/api/admin/application/${id}/finish/a`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

AdminApplicationService.finishApplicationB = async (id) => {
  return axios({
    method: "post",
    url: API_BASE_URL + `/api/admin/application/${id}/finish/b`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

AdminApplicationService.finishApplicationC = async (id) => {
  return axios({
    method: "post",
    url: API_BASE_URL + `/api/admin/application/${id}/finish/c`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

AdminApplicationService.rejectApplication = async (id) => {
  return axios({
    method: "post",
    url: API_BASE_URL + `/api/admin/application/${id}/reject`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  });
};

export default AdminApplicationService;
